import SidebarStore from './sidebar.store'
import WaterStore from './water.store'
import SoilStore from './soil.store'
import TissueStore from './tissue.store'
import MediaStore from './media.store'

export default {
  namespaced: true,
  modules: {
    'sidebar': SidebarStore,
    'water': WaterStore,
    'soil': SoilStore,
    'tissue': TissueStore,
    'media': MediaStore,
  },
  state: {

    create_modal_opened: false,
    interpretations: {
      0: 'None',
      1: 'Low',
      2: 'Adequate',
      3: 'High',
      4: 'Excessive',
    },
  },
  mutations: {
    openCreateModal(state) {
      state.create_modal_opened = true;
    },
    closeCreateModal(state) {
      state.create_modal_opened = false;
    }
  },
  actions: {


  },
  getters: {
    isCreateModalOpened(state) {
      return state.create_modal_opened;
    },
    interpretations(state) {
      return state.interpretations;
    }
  }
};
